// ChatBotContainer.jsx
"use client";

import { useEffect, useRef, useState } from "react";
import Chatbot from "react-chatbot-kit";
import config from "./config";
import MessageParser from "./MessageProvider";
import ActionProvider from "./ActionProvider";
import "react-chatbot-kit/build/main.css";

export default function ChatBotContainer() {
  const [isOpen, setIsOpen] = useState(false);
  const timerRef = useRef(null);

  // Auto-open after 5s once the component is mounted on the client
  useEffect(() => {
    // sanity: ensure we're on the client
    if (typeof window === "undefined") return;

    // start timer
    timerRef.current = window.setTimeout(() => {
      setIsOpen(true);
    }, 5000);

    // cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  const openNow = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setIsOpen(true);
  };

  const closeNow = () => setIsOpen(false);

  return (
    <>
      {!isOpen && (
        <button
          onClick={openNow}
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            backgroundColor: "#0065FF",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 60,
            height: 60,
            fontSize: 24,
            cursor: "pointer",
            zIndex: 1000
          }}
          aria-label="Open chat"
        >
          💬
        </button>
      )}

      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: 90,
            right: 20,
            zIndex: 9999,
            width: 370,
            maxWidth: "80vw",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            borderRadius: 10,
            overflow: "hidden",
            backgroundColor: "#fff"
          }}
        >
          {/* Header with close icon */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 10px",
              backgroundColor: "#0065FF",
              color: "#fff"
            }}
          >
            <span>AI Assistant</span>
            <button
              onClick={closeNow}
              style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer", padding: 4 }}
              aria-label="Close chat"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.42L12 13.41l4.89 4.9a1 1 0 0 0 1.42-1.41L13.41 12l4.9-4.89a1 1 0 0 0-.01-1.4Z" />
              </svg>
            </button>
          </div>

          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        </div>
      )}
    </>
  );
}
